var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('h1',{attrs:{"align":"center"}},[_vm._v("Dynamic View Test for DEMO COMPANY")]),_c('Dashboard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }